import * as React from 'react'
import classNames from 'classnames'
import { AWS_S3_URL } from 'utils/constants'
import { Field, Form, useField } from 'react-final-form'
import { FileUploader, FormError } from '@conekta/ui-component-library'
import { IMimeTypes } from '../../../Documents/interface'
import { ITraditionalContractForm } from './interface'
import { ModalActions } from 'components/Modal/ModalActions/ModalActions'
import { useTranslation } from 'react-i18next'

const { useEffect, useState } = React
const T_ROOT = 'contract.traditionalContract'

const ContractTraditional = ({ fileTypes, handleCancel, handleSubmit }: ITraditionalContractForm): JSX.Element => {
  const [fileMaxSizeAllowed, setFileMaxSizeAllowed] = useState(0)
  const [mimeTypes, setMimeTypes] = useState('')
  const { t } = useTranslation()
  const CONTRACT_ADDRESS = `${AWS_S3_URL}/docs/ConektaContract.pdf`
  const MAX_FILE_NAME_CHARS = 50

  useEffect(() => {
    const FILE_TYPES = fileTypes
    if (FILE_TYPES.length) {
      const MIME_TYPES = FILE_TYPES.map(({ mimeType }: IMimeTypes) => mimeType)
      setMimeTypes(MIME_TYPES.join(', '))
      setFileMaxSizeAllowed(FILE_TYPES[0].maxSize || 0)
    }
  }, [])

  return (
    <>
      <p className='ContractTraditional__Modal-instructions'>{t(`${T_ROOT}.instructions`)}</p>
      <div className='ContractTraditional__Modal-download'>
        <a download='Contrato_Conekta.pdf' href={CONTRACT_ADDRESS} target='_blank' rel='noreferrer'>
          <i className='icon-url'></i>
          <p>{t(`${T_ROOT}.downloadButton`)}</p>
        </a>
      </div>
      <p className='ContractTraditional__Modal-text'>{t(`${T_ROOT}.uploadContract`)}</p>
      <div className='ContractTraditional__Modal-form'>
        <Form
          onSubmit={handleSubmit}
          render={({ handleSubmit, submitting }): JSX.Element => (
            <form onSubmit={handleSubmit}>
              <Field name='contract'>
                {({ input, meta }): JSX.Element => (
                  <fieldset>
                    <FileUploader
                      {...{ input, meta }}
                      className={classNames('ContractTraditional__FileUploader', {
                        required: (!!meta && meta.error && meta.touched) || false
                      })}
                      fileTypes={mimeTypes}
                      maxSize={fileMaxSizeAllowed}
                      placeholder={t(`${T_ROOT}.fileUploaderPlaceholder`)}
                    />
                    <FormError {...{ useField }} name='contract' />
                  </fieldset>
                )}
              </Field>
              <ModalActions
                cancelButton={{
                  text: t(`${T_ROOT}.cancelButton`),
                  handleClick: handleCancel
                }}
                confirmButton={{
                  text: t(`${T_ROOT}.acceptButton`),
                  disabled: submitting,
                  loading: submitting
                }}
              />
            </form>
          )}
          validate={(values: any) => {
            const ERRORS: any = {}
            if (!values.contract) {
              ERRORS.contract = t(`${T_ROOT}.error.contract`)
            } else if (values.contract.name.length > MAX_FILE_NAME_CHARS) {
              ERRORS.contract = t(`${T_ROOT}.error.max_chars`) + MAX_FILE_NAME_CHARS.toString()
            }
            return ERRORS
          }}
        />
      </div>
    </>
  )
}

export default ContractTraditional
